<template>
  <div>
    <van-cell class="ry-form__date-input" v-if="isNormalStyle">
      <template slot="title">
        <span class="title">{{current.title}}</span>
        <span style="color: red" v-if="!isRead && current.required">*</span>
      </template>
      <template slot="label">

        <template v-if="current.fieldHint">
          <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
          <div
            v-else
            class="ql-editor"
            v-html="current.fieldHint">
          </div>
        </template>
        <div
          v-if="isRead">
          {{content}}
        </div>
        <van-field
          v-if="!isRead"
          :readonly="isReadOnly"
          :value="currentContent"
          @focus="inputFocus"
          @blur="inputBlur"
          :placeholder="current.fieldDes"
          :error-message="errorMessage">
        </van-field>

      </template>
    </van-cell>

    <div v-else class="ry-form-item-compact ry-form__date-input-compact">

      <van-field
        v-if="isRead"
        :label="current.title"
        :required="Boolean(!isRead && current.required)">
        <template #input>
          <div>
            {{content}}
          </div>
        </template>
      </van-field>

      <van-field
        v-if="!isRead"
        :label-class="{'readonly-field-label': isReadOnly}"
        :readonly="isReadOnly"
        :value="currentContent"
        @focus="inputFocus"
        @blur="inputBlur"
        :placeholder="current.fieldDes || isReadOnly ? '暂无内容' : '请填写内容'"
        :label="current.title"
        :required="Boolean(!isRead && current.required)">
        <template #button>
          <van-icon
            v-if="currentRow[dataId] && !isReadOnly"
            name="close"
            class="close-btn"
            @click.stop="clearData">
          </van-icon>
        </template>
      </van-field>
    </div>

    <van-popup
      position="bottom"
      get-container="body"
      :style="{ height: '40%' }"
      v-model="show">
      <van-datetime-picker
        @confirm="onConfirm"
        @cancel="onCancel"
        :type="currentDateType"
        v-model="defaultDate"
        :min-date="new Date('1870')"
        :max-date="new Date('2120')">
      </van-datetime-picker>
    </van-popup>

    <RySelectPopup
      v-if="current.pluginConfig && current.pluginConfig.entryId"
      ref="rySelectPopup"
      :title="current.title"
      @selectComplete="selectComplete">
    </RySelectPopup>
  </div>

</template>

<script>
  import { current } from './mixin'
  import { formatDate } from '../../utils'
  import { DATE_TYPE__DAY, DATE_TYPE__SECTION } from '../../types'

  export default {
    mixins: [current],
    data () {
      return {
        show: false,
        isError: false,
        DATE_TYPE__DAY
      }
    },
    created() {
      if (!this.currentRow[this.current.dataId]) {
        this.currentRow[this.current.dataId] = null
      }
    },
    computed: {
      content() {
        if (Object.prototype.toString.call(this.currentRow[this.dataId]) === '[object Null]' ||
          Object.prototype.toString.call(this.currentRow[this.dataId]) === '[object Undefined]') {
          return '暂无内容'
        } else {
          return this.formatDate(this.currentRow[this.current.dataId])
        }
      },
      defaultDate: {
        get () {
          if (Object.prototype.toString.call(this.currentRow[this.dataId]) === '[object Null]' ||
            Object.prototype.toString.call(this.currentRow[this.dataId]) === '[object Undefined]') {
            return new Date()
          } else {
            return new Date(this.currentRow[this.dataId])
          }
        },
        set (date) {}
      },
      errorMessage () {
        return this.isError ? this.current.requiredShowText : ''
      },
      currentContent() {

        console.log('currentContent', this.currentRow[this.dataId]);
        if (Object.prototype.toString.call(this.currentRow[this.dataId]) === '[object Null]' ||
          Object.prototype.toString.call(this.currentRow[this.dataId]) === '[object Undefined]') {
          return ''
        } else {
          return this.formatDate(this.currentRow[this.dataId])
        }
      },
      currentDateType() {
        if (this.current.dateType === DATE_TYPE__SECTION) {
          return 'datetime'
        } else {
          return 'date'
        }
      }
    },
    methods: {
      formatDate (val) {
        let format = 'yyyy-MM-dd'
        if (this.current.dateType === DATE_TYPE__SECTION) {
          format = 'yyyy-MM-dd HH:mm'
        }
        return formatDate(val)(format)
      },
      onConfirm (date) {
        this.show = false
        this.currentRow[this.dataId] = +date
        this.selectChange()
      },
      onCancel() {
        this.show = false
        if (!this.currentRow[this.current.dataId]) {
          this.currentRow[this.current.dataId] = 0
        }
      },
      inputFocus (event) {
        if (this.isReadOnly) return
        this.show = true
        event.target.blur()
        if (!this.currentRow[this.current.dataId]) {
          this.currentRow[this.current.dataId] = null
        }
      },
      inputBlur () {
        this.isError = this.current.checkMissValue && this.isShowRequiredText
      },
      selectChange() {
        this.controlChange()
        this.submitData()
      },
      clearData() {
        this.currentRow[this.dataId] = null
        this.selectChange()
      }
    }
  }
</script>

<style lang="less">
  .ry-form__date-input {

    .van-field__body {
      margin-right: 0 !important;
    }

    .van-field__button {
      margin-right: -5px;

      i {
        color: #969799;
      }
    }
  }
</style>